import { render, staticRenderFns } from "./new-comment-reply.vue?vue&type=template&id=168e680b&scoped=true&"
import script from "./new-comment-reply.vue?vue&type=script&setup=true&lang=js&"
export * from "./new-comment-reply.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./new-comment-reply.vue?vue&type=style&index=0&id=168e680b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e680b",
  null
  
)

export default component.exports